module.exports = __webpack_public_path__ + "img/export_orders_icon.a73f2212.svg";